// An Alpine show-more toggle that stays expanded when the user navigates back
// to the page. Without it, the page re-renders collapsed on back (a full reload
// when Turbo Drive is disabled, or a Turbo snapshot restore that re-runs
// x-data), so the restored scroll position lands somewhere else entirely.
//
// The expanded state is remembered per URL in sessionStorage and only honored
// for back/forward renders: a fresh visit to the same page starts collapsed.
//
// Usage: x-data="restorableToggle('ingredients-explained')", then read and set
// `expanded`.

let restoring = performance.getEntriesByType("navigation")[0]?.type === "back_forward";

document.addEventListener("turbo:visit", (event) => {
  restoring = event.detail.action === "restore";
});

document.addEventListener("alpine:init", () => {
  window.Alpine.data("restorableToggle", (name) => ({
    expanded: false,

    init() {
      const key = `restorable-toggle:${window.location.pathname}${window.location.search}:${name}`;

      if (restoring && sessionStorage.getItem(key) === "1") {
        this.expanded = true;
      } else {
        sessionStorage.removeItem(key);
      }

      this.$watch("expanded", (value) => {
        if (value) {
          sessionStorage.setItem(key, "1");
        } else {
          sessionStorage.removeItem(key);
        }
      });
    },
  }));
});
